import ApplicationModel, { attr } from '../ApplicationModel';
import { type AiUserAgentFavoriteAttributes } from './generated/AiUserAgentFavoriteAttributes';
import { model } from '../modelBuilder';

interface AiUserAgentFavorite extends AiUserAgentFavoriteAttributes {}

@model
class AiUserAgentFavorite extends ApplicationModel {
  // Start auto-generated
  static typename: 'AiUserAgentFavorite' = 'AiUserAgentFavorite';
  get typename(): 'AiUserAgentFavorite' {
    return 'AiUserAgentFavorite';
  }

  static internalTypename: 'AiUserAgentFavorite' = 'AiUserAgentFavorite';
  get internalTypename(): 'AiUserAgentFavorite' {
    return 'AiUserAgentFavorite';
  }

  static inputType = 'AiUserAgentFavoriteAttributes!';

  static fields = {
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    position: attr({ writable: true, readable: true }),
    updatedAt: attr({ readable: true }),
    aiUserAgent: attr.belongsTo({
      writeShape: ['id'],
      readable: true,
      typename: 'AiUserAgent',
    }),
    user: attr.belongsTo({ readable: true, typename: 'User' }),
  };
  // End auto-generated
}

export default AiUserAgentFavorite;
